import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import InputField from '@/components/neue/InputField.vue'
import SettingCard from '@/components/settings/SettingCard.vue'
import SettingRow from '@/components/settings/SettingRow.vue'

const DESCRIPTION = 'Give customers Paytronix loyalty points for their orders.'
const GROUP_HINT = 'The merchant ID Paytronix gave your brand.'
const STORE_HINT = 'The code Paytronix uses for this location.'


export default {
  __name: 'PaytronixCard',
  props: {
  groupId: { type: [String, Number], default: '' },
  storeId: { type: [String, Number], default: '' }
},
  emits: ['update:groupId', 'update:storeId'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(SettingCard, {
    name: "Paytronix",
    description: DESCRIPTION
  }, {
    default: _withCtx(() => [
      _createVNode(SettingRow, {
        label: "Group ID",
        hint: GROUP_HINT
      }, {
        default: _withCtx(() => [
          _createVNode(InputField, {
            "model-value": props.groupId,
            "aria-label": "Paytronix group ID",
            autocomplete: "off",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = value => emit('update:groupId', value))
          }, null, 8, ["model-value"])
        ]),
        _: 1
      }),
      _createVNode(SettingRow, {
        label: "Store ID",
        hint: STORE_HINT
      }, {
        default: _withCtx(() => [
          _createVNode(InputField, {
            "model-value": props.storeId,
            "aria-label": "Paytronix store ID",
            autocomplete: "off",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = value => emit('update:storeId', value))
          }, null, 8, ["model-value"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

}